import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import RawMaterialsComponent from './raw-materials.component';

let RawMaterialsModule = angular
  .module('RawMaterials', [
    uiRouter
  ])
  .component('rawmaterials', RawMaterialsComponent)
  .config(($stateProvider) => {
    'ngInject';
    $stateProvider.state('rawMaterials', {
      url: '/raw-materials',
      data: {
        authRequired: true
      },
      views: {
        'menu': 'menu',
        'content': {
          component:'rawmaterials'
        }
      }
    });
  })
  .name;

export default RawMaterialsModule;



// WEBPACK FOOTER //
// ./src/app/pages/raw-materials/raw-materials.module.js